import { iconLibrarySchema } from '@basehub/data/replicache/index'
import { useQuery } from '@tanstack/react-query'

export const useIconLibrary = () => {
  const data = useQuery({
    queryKey: ['basehub-icon-library'],
    queryFn: async () => {
      const lib = await fetch('/api/icon-library')
        .then((r) => r.json())
        .then((json) => iconLibrarySchema.parse(json))

      return lib
    },
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnReconnect: true,
    keepPreviousData: true,
  })

  return data
}
